// Typelizer digest b2e3208235c7548ee140ad35b455b32f
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** PATCH /c/:company_id/ledger/documents/:document_id/posting_rule */
  update: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/ledger/documents/:document_id/posting_rule', params, options),
    method: 'patch',
  }),
}
